import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Unstable_Grid2';
import RegistrationDateSelector from '../molecules/RegistrationDateSelector';
import { useState, useEffect } from 'react';
import { Paper } from '@mui/material';

const RegistrationChildPersonalInfo = ({
  childObject,
  updateChild,
  clearDateTrigger,
  validation,
}) => {
  const [dob, setDob] = useState('');

  useEffect(() => {
    const dobFormatted = {
      name: 'dob',
      value: dob,
    };
    updateChild(dobFormatted);
  }, [dob]);

  const handleFormChange = e => {
    updateChild(e.target);
  };

  return (
    <Paper elevation={5} sx={{ padding: '20px' }}>
      <TextField
        fullWidth
        error={validation.bc_name}
        helperText={
          validation.bc_name &&
          "Please enter Child's name as in Passport / Birth Certificate"
        }
        required
        name='bc_name'
        label='Name in Birth Certificate / Passport'
        margin='dense'
        value={childObject['bc_name']}
        onChange={handleFormChange}
        inputProps={{ 'data-cy': 'child-name' }}
        id='child-name'
      />
      <TextField
        fullWidth
        required
        error={validation.first_name}
        helperText={validation.first_name && 'Please provide a first name'}
        name='first_name'
        label='First Name'
        margin='dense'
        value={childObject['first_name']}
        onChange={handleFormChange}
        inputProps={{ 'data-cy': 'child-first-name' }}
        id='child-first-name'
      />
      <TextField
        fullWidth
        required
        error={validation.last_name}
        helperText={validation.last_name && 'Please provide a last name'}
        label='Last Name'
        name='last_name'
        margin='dense'
        value={childObject['last_name']}
        onChange={handleFormChange}
        inputProps={{ 'data-cy': 'child-last-name' }}
        id='child-last-name'
      />

      <TextField
        fullWidth
        required
        select
        error={validation.gender}
        helperText={
          validation.gender && 'Please select a gender for your Child'
        }
        name='gender'
        label='Gender'
        margin='dense'
        value={childObject['gender'] ?? ''}
        onChange={handleFormChange}
        id='child-gender'
      >
        <MenuItem key='M' value='M'>
          Male
        </MenuItem>
        <MenuItem key='F' value='F'>
          Female
        </MenuItem>
      </TextField>

      <RegistrationDateSelector
        dateObjSetter={setDob}
        clearDateTrigger={clearDateTrigger}
        required={true}
        validationState={validation.dob}
        testid='dob'
      />

      <Grid container spacing={2}>
        <Grid xs={4}>
          <TextField
            fullWidth
            select
            error={validation.id_type}
            helperText={validation.id_type && 'Please select an ID type'}
            required
            label='ID Type'
            value={childObject['id_type'] ?? ''}
            name='id_type'
            margin='dense'
            onChange={handleFormChange}
            id='child-id-type'
            inputProps={{ 'data-cy': 'child-id' }}
          >
            <MenuItem key='bc' value='bc'>
              Singapore Birth Certificate
            </MenuItem>
            <MenuItem key='fin' value='fin'>
              Foreign Identification Number
            </MenuItem>
          </TextField>
        </Grid>
        <Grid xs={8}>
          <TextField
            fullWidth
            required
            error={validation.id_number}
            helperText={validation.id_number && 'Please enter your ID Number'}
            label=' ID Number'
            name='id_number'
            margin='dense'
            onChange={handleFormChange}
            value={childObject['id_number']}
            inputProps={{ 'data-cy': 'child-id-number' }}
            id='child-id-number'
          />
          <span className=' text-xs'>Last 4 characters only</span>
        </Grid>
      </Grid>

      <TextField
        fullWidth
        label='Student Mobile Number (Optional)'
        name='mobile'
        margin='dense'
        value={childObject['mobile']}
        onChange={handleFormChange}
        inputProps={{ 'data-cy': 'child-mobile' }}
      />
    </Paper>
  );
};

export default RegistrationChildPersonalInfo;
